import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'
import { Welcome, Workspace } from '../layout'

Vue.use(VueRouter)

const router = new VueRouter({
  // Keycloak doesn't work with hash mode, because
  // the redirection gets messed up and results in an
  // infinite redirection loop or bad gateway.
  // @see https://router.vuejs.org/en/essentials/history-mode.html
  mode: 'history',
  // Don't fallback to hash mode when the browser does not
  // support history.pushState
  // @see https://router.vuejs.org/en/api/options.html#fallback
  fallback: false,
  routes: [
    {
      path: '/workspace',
      name: 'Workspace',
      component: Workspace,
      meta: {auth: true}
    },
    {
      path: '/:accountId/workspace',
      name: 'AccountWorkspace',
      component: Workspace,
      meta: {auth: true}
    },
    {
      path: '/:accountId',
      name: 'AccountWelcome',
      component: Welcome
    },
    {
      path: '/',
      name: 'Welcome',
      component: Welcome
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.auth)) {
    return next()
  }

  // Not sure on how to access keycloak
  const keycloak = new Vue().$keycloak
  if (keycloak.ready && keycloak.authenticated) {
    // Allow transition if keycloak authenticated user
    return next()
  } else {
    // Transition to index/welcome page
    if (to.params.accountId) {
      return next('/' + to.params.accountId)
    }
    return next('/')
  }
})

if (process.env.GOOGLE_ANALYTICS_ID) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS_ID,
    router
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js